import { JSONSchemaType } from 'ajv'
import { IProfileOptionFormData } from './profile-option'

export interface IProfileSecurityFormData {
  id: string
  name: string
  userGroupId: string
  disabled: boolean
  menuOptions: IProfileOptionFormData[]
}

const ProfileSecuritySchema: JSONSchemaType<IProfileSecurityFormData> = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    userGroupId: {
      type: 'string',
    },
    disabled: {
      type: 'boolean',
    },
    menuOptions: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: {
            type: 'string',
          },
          profileId: {
            type: 'string',
          },
          menuOptionKey: {
            type: 'string',
          },
          permitAll: {
            type: 'boolean',
          },
          permitCreate: {
            type: 'boolean',
          },
          permitRestore: {
            type: 'boolean',
          },
          permitUpdate: {
            type: 'boolean',
          },
          permitDelete: {
            type: 'boolean',
          },
          disabled: {
            type: 'boolean',
          },
          createdAt: {
            type: 'string',
          },
          updatedAt: {
            type: 'string',
          },
        },
        required: ['menuOptionKey', 'profileId'],
        additionalProperties: false,
      },
      default: [],
    },
  },
  required: ['name'],
  additionalProperties: false,
}

export default ProfileSecuritySchema
